export default {
    // #region auth
    UPDATE_PHONE_CALL: 'UPDATE_PHONE_CALL',
    // #update phone
    //Update sip_id
    IS_USER_INCALL : 'IS_USER_INCALL',

};
